function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1988(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 12.35,
    height: 2.21,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 0.36833333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.175,
    y: 1.105
  }, "\n        Alpine\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 2.21,
    width: 12.35,
    height: 6.8,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.1333333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.175,
    y: 5.609999999999999
  }, "\n        Sierra\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 9.02,
    width: 12.35,
    height: 14.23,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.0875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.175,
    y: 16.134999999999998
  }, "\n        Mono\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 23.25,
    width: 12.35,
    height: 16.12,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.4699999999999998
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.175,
    y: 31.310000000000002
  }, "\n        Modoc\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 39.37,
    width: 12.35,
    height: 20.75,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.058333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.175,
    y: 49.745
  }, "\n        Colusa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 60.12,
    width: 12.35,
    height: 23.99,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.7642857142857142
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.175,
    y: 72.115
  }, "\n        Trinity\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 84.11,
    width: 12.35,
    height: 27.72,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.54375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.175,
    y: 97.97
  }, "\n        Mariposa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 111.83,
    width: 12.35,
    height: 29.96,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.3722222222222222
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.175,
    y: 126.81
  }, "\n        Del_Norte\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 141.79,
    width: 12.35,
    height: 31.44,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.0875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.175,
    y: 157.51
  }, "\n        Inyo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 173.23,
    width: 12.35,
    height: 31.96,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.4699999999999998
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.175,
    y: 189.20999999999998
  }, "\n        Glenn\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 205.19,
    width: 12.35,
    height: 35.31,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.058333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.175,
    y: 222.845
  }, "\n        Lassen\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 240.51,
    width: 12.35,
    height: 36.17,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.058333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.175,
    y: 258.59499999999997
  }, "\n        Plumas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 276.67,
    width: 12.35,
    height: 41.36,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.2349999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.175,
    y: 297.35
  }, "\n        San_Benito\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 318.03,
    width: 12.35,
    height: 49.5,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.058333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.175,
    y: 342.78
  }, "\n        Amador\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 367.53,
    width: 12.35,
    height: 54.46,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.3722222222222222
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.175,
    y: 394.76
  }, "\n        Calaveras\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 421.99,
    width: 12.35,
    height: 58.43,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.0875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.175,
    y: 451.205
  }, "\n        Yuba\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 480.41,
    width: 12.35,
    height: 69.94,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.058333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.175,
    y: 515.38
  }, "\n        Tehama\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 550.36,
    width: 12.35,
    height: 71.4,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.54375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.175,
    y: 586.0600000000001
  }, "\n        Siskiyou\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 621.76,
    width: 12.35,
    height: 78.24,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.0875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.175,
    y: 660.88
  }, "\n        Lake\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12.35,
    y: 0,
    width: 21.89,
    height: 44.64,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.73625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 23.295,
    y: 22.32
  }, "\n        Tuolumne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 34.24,
    y: 0,
    width: 23.2,
    height: 44.64,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.8666666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 45.84,
    y: 22.32
  }, "\n        Sutter\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 57.44,
    y: 0,
    width: 23.85,
    height: 44.64,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.7700000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 69.365,
    y: 22.32
  }, "\n        Kings\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.29,
    y: 0,
    width: 25.94,
    height: 44.64,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.2425
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 94.26,
    y: 22.32
  }, "\n        Imperial\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 107.23,
    y: 0,
    width: 26.96,
    height: 44.64,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.493333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 120.71000000000001,
    y: 22.32
  }, "\n        Madera\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 134.19,
    y: 0,
    width: 34.36,
    height: 44.64,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.8177777777777777
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 151.37,
    y: 22.32
  }, "\n        Mendocino\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 168.54,
    y: 0,
    width: 41.1,
    height: 44.64,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.8500000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 189.09,
    y: 22.32
  }, "\n        Nevada\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 209.65,
    y: 0,
    width: 47.09,
    height: 44.64,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.44
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 233.195,
    y: 22.32
  }, "\n        Merced\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 256.73,
    y: 0,
    width: 51.39,
    height: 44.64,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.16
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 282.425,
    y: 22.32
  }, "\n        Napa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 308.13,
    y: 0,
    width: 56.18,
    height: 44.64,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.96
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 336.21999999999997,
    y: 22.32
  }, "\n        El_Dorado\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 364.3,
    y: 0,
    width: 57.89,
    height: 44.64,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.58
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 393.245,
    y: 22.32
  }, "\n        Humboldt\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 422.2,
    y: 0,
    width: 59.25,
    height: 44.64,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.16
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 451.825,
    y: 22.32
  }, "\n        Yolo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 481.45,
    y: 0,
    width: 60.6,
    height: 44.64,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.44
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 511.75,
    y: 22.32
  }, "\n        Shasta\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 542.05,
    y: 0,
    width: 78.43,
    height: 44.64,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.44
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 581.265,
    y: 22.32
  }, "\n        Placer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 620.48,
    y: 0,
    width: 79.52,
    height: 44.64,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.928
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 660.24,
    y: 22.32
  }, "\n        Butte\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12.35,
    y: 44.64,
    width: 73.19,
    height: 53.27,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.878333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 48.945,
    y: 71.275
  }, "\n        Tulare\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12.35,
    y: 97.91,
    width: 73.19,
    height: 56.52,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.7680000000000002
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 48.945,
    y: 126.17
  }, "\n        San_Luis_Obispo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12.35,
    y: 154.43,
    width: 73.19,
    height: 65.9,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.590000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 48.945,
    y: 187.38
  }, "\n        Stanislaus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12.35,
    y: 220.32,
    width: 73.19,
    height: 67.97,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.49625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 48.945,
    y: 254.305
  }, "\n        Monterey\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12.35,
    y: 288.29,
    width: 73.19,
    height: 69.48,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.948
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 48.945,
    y: 323.03000000000003
  }, "\n        Santa_Cruz\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12.35,
    y: 357.78,
    width: 73.19,
    height: 71.84,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.973333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 48.945,
    y: 393.7
  }, "\n        Solano\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12.35,
    y: 429.61,
    width: 73.19,
    height: 79.85,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.638
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 48.945,
    y: 469.535
  }, "\n        Marin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12.35,
    y: 509.46,
    width: 73.19,
    height: 93.75,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.653636363636363
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 48.945,
    y: 556.335
  }, "\n        San_Joaquin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12.35,
    y: 603.21,
    width: 73.19,
    height: 96.79,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.63
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 48.945,
    y: 651.605
  }, "\n        Santa_Barbara\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 85.54,
    y: 44.64,
    width: 71.26,
    height: 102.44,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 17.815
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 121.17000000000002,
    y: 95.86
  }, "\n        Kern\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 156.8,
    y: 44.64,
    width: 78.17,
    height: 102.44,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.028333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 195.88500000000002,
    y: 95.86
  }, "\n        Sonoma\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 234.97,
    y: 44.64,
    width: 91.86,
    height: 102.44,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.31
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 280.9,
    y: 95.86
  }, "\n        Fresno\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 326.83,
    y: 44.64,
    width: 115.85,
    height: 102.44,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 14.634285714285713
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 384.755,
    y: 95.86
  }, "\n        Ventura\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 442.69,
    y: 44.64,
    width: 123.11,
    height: 102.44,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.382222222222222
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 504.245,
    y: 95.86
  }, "\n        San_Mateo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 565.8,
    y: 44.64,
    width: 134.2,
    height: 102.44,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.88
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 632.9,
    y: 95.86
  }, "\n        San_Francisco\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 85.54,
    y: 147.08,
    width: 130.47,
    height: 125.93,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.494166666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 150.775,
    y: 210.04500000000002
  }, "\n        Contra_Costa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 85.54,
    y: 273.01,
    width: 130.47,
    height: 127.77,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.196666666666665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 150.775,
    y: 336.895
  }, "\n        Riverside\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 85.54,
    y: 400.78,
    width: 130.47,
    height: 148.91,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.319285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 150.775,
    y: 475.23499999999996
  }, "\n        San_Bernardino\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 85.54,
    y: 549.69,
    width: 130.47,
    height: 150.31,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.047
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 150.775,
    y: 624.845
  }, "\n        Sacramento\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 216.01,
    y: 147.08,
    width: 122.93,
    height: 193.11,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 17.56142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 277.475,
    y: 243.63500000000002
  }, "\n        Alameda\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 338.94,
    y: 147.08,
    width: 138.98,
    height: 193.11,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.634545454545453
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 408.43,
    y: 243.63500000000002
  }, "\n        Santa_Clara\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 477.92,
    y: 147.08,
    width: 222.08,
    height: 193.11,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 32.185
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 588.96,
    y: 243.63500000000002
  }, "\n        Orange\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 216.01,
    y: 340.19,
    width: 119.72,
    height: 359.81,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.302222222222222
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 275.87,
    y: 520.095
  }, "\n        San_Diego\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 335.73,
    y: 340.19,
    width: 364.27,
    height: 359.81,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 32.71
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 517.865,
    y: 520.095
  }, "\n        Los_Angeles\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1988);
export default __webpack_public_path__ + "static/media/1988.ef7a5706773ddf78e0ca140ea0dc73b8.svg";
export { ForwardRef as ReactComponent };